// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import Dayjs from "dayjs";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Caml_option from "../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Config$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as BrowserUtils$PorterinFeature from "./browser/BrowserUtils.mjs";

function createBufferWithNextLine(data) {
  return Buffer.from(data + "\n", "utf-8");
}

function validateNumber(code) {
  return /^[0-9]+$/.test(code);
}

function logger(callback) {
  switch (Config$PorterinUtils.env) {
    case "prod" :
    case "production" :
        return ;
    default:
      return Curry._1(callback, undefined);
  }
}

function extractParam(key, params) {
  var value = Js_dict.get(params, key);
  if (value !== undefined) {
    return value;
  } else {
    return "";
  }
}

function getCurrentTime(format) {
  return Dayjs().format(format);
}

function debounce(callback, delay) {
  var timeoutId = {
    contents: undefined
  };
  return function (args) {
    var id = timeoutId.contents;
    if (id !== undefined) {
      clearTimeout(Caml_option.valFromOption(id));
    }
    timeoutId.contents = Caml_option.some(setTimeout((function (param) {
                Curry._1(callback, args);
              }), delay));
  };
}

function getRandomIdName(prefix) {
  var randomIdAsString = String(Math.random());
  return prefix + "-" + randomIdAsString;
}

function webViewDismiss(param) {
  if (BrowserUtils$PorterinFeature.isAndroid(undefined)) {
    BrowserUtils$PorterinFeature.androidDismiss(undefined);
  }
  if (BrowserUtils$PorterinFeature.isIos(undefined)) {
    return BrowserUtils$PorterinFeature.iosDismiss(undefined);
  }
  
}

export {
  createBufferWithNextLine ,
  validateNumber ,
  logger ,
  extractParam ,
  getCurrentTime ,
  debounce ,
  getRandomIdName ,
  webViewDismiss ,
}
/* dayjs Not a pure module */
